import type {} from '@tanstack/react-query';

import { _get } from './Get';
import { _update } from './Update';

export namespace useFeatureFlag {
  export const Get: typeof _get = _get;
  export const Update: typeof _update = _update;
}
export { featureFlagQueryKeys } from './queryKeys';
